<template>
  <main>
    <div class="content">
      <h1>Aide</h1>
      <h4>Débug : Données utilisateur</h4>
      <pre>{{ JSON.stringify(userProfile, undefined, 4) }} </pre>
    </div>
  </main>
</template>

<style scoped>
div.content {
  padding: 0 40px;
}

pre {
  padding: 20px;
  background-color: #222;
  border-radius: 8px;
  color: white;
}
</style>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["userProfile"]),
  },
};
</script>